// export const apiUrl = "http://127.0.0.1:8000/api/"
export const apiUrl = "https://rizwanali.pythonanywhere.com/api/"